module.exports = __webpack_public_path__ + "img/9791195847419.50643e66.jpg";